import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_instructor/my-courses')({
  component: () => <Outlet />,
});
